import React from 'react';
import { RenderElementProps } from 'slate-react';
import { ElementTypes } from 'src/types/CustomSlateTypes';
import QuoteElement from 'src/components/RichTextEditor/quote/index';
import Link from './LinkButton/Link';
import ImageElement from './image/ImageElement';
import MentionElement from './mention/MentionElement';

const Element = (props: RenderElementProps) => {
  const { attributes, children, element } = props;

  switch (element.type) {
    case ElementTypes.bulletedList:
      return (
        <ul {...attributes}>
          {children}
        </ul>
      );
    case ElementTypes.listItem:
      return (
        <li {...attributes}>
          {children}
        </li>
      );
    case ElementTypes.numberedList:
      return (
        <ol {...attributes}>
          {children}
        </ol>
      );
    case ElementTypes.link:
      return (
        <Link {...props} element={element}>
          {children}
        </Link>
      );
    case ElementTypes.image:
      return <ImageElement {...props} element={element} />;
    case ElementTypes.mention:
      return <MentionElement {...props} element={element} />;
    case ElementTypes.quote:
      return <QuoteElement {...props} element={element} />;
    case ElementTypes.paragraph:
    default:
      return (
        <p {...attributes}>
          {children}
        </p>
      );
  }
};

export default Element;
